import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import _useTranslate from '../../hooks/_useTranslate';

const FooterUsefullMenu = ({ feathersStore }) => {
    const footer = _useTranslate(feathersStore.language, "footer");

    return (
        <div className="footer-menu-section">
            <h3 className="footer-section-header">{footer.usefull}</h3>
            <div className="footer-menu-links">
                <Link to="/paymentoptions" className="footer-menu-link">
                    {footer.paymentOptions}
                </Link>
                <Link to="/deliveryoptions" className="footer-menu-link">
                    {footer.deliveryOptions}
                </Link>
                <Link to="/faq" className="footer-menu-link">
                    {footer.faq}
                </Link>
                <Link to="/contact" className="footer-menu-link">
                    {footer.contactUs}
                </Link>
            </div>
        </div>
    );
};

export default inject('feathersStore')(observer(FooterUsefullMenu));